import React from "react";
import {
  TopNavigation,
  TopNavigationProps,
} from "@amzn/awsui-components-react-v3/polaris";
import logo from "../images/leo-logo-light.png";
import { PhoneToolUserUrl, PagePaths, AppTitles } from "../lib/constants";
import { SearchBar } from "./search-bar";
import { formatRoute } from "../utils/route";
import { getAppConfig } from "../services/config";

interface NavigationProps {
  loggedInUsername?: string;
  loggedInAlias?: string;
  logout: () => void;
  showSearch?: boolean;
  title?: string;
}

const DefaultTopNavigation = ({
  loggedInUsername,
  loggedInAlias,
  logout,
  showSearch,
  title = AppTitles.DEFAULT,
}: NavigationProps) => {
  const config = getAppConfig();

  const navigationIdentity = {
    href: PagePaths.HOME,
    title: `${title}${config.isProd ? "" : ` - ${config.envName}`}`,
    logo: { src: logo, alt: "Amazon Leo logo" },
  };

  const navigationUtilities: TopNavigationProps.Utility[] = [
    {
      type: "button",
      text: loggedInUsername,
      href: formatRoute(PhoneToolUserUrl, {
        routeParams: { alias: loggedInAlias ?? "" },
      }),
      iconName: "user-profile",
      external: false,
      externalIconAriaLabel: " (opens in new tab)",
    },
    {
      type: "button",
      text: "Log out",
      onClick: logout,
      external: false,
    },
  ];

  return (
    <TopNavigation
      identity={navigationIdentity}
      utilities={navigationUtilities}
      search={showSearch ? <SearchBar /> : undefined}
    />
  );
};

export default DefaultTopNavigation;
